import { Flex, FlexProps } from '@chakra-ui/react';
import React, { ReactElement } from 'react';

interface Props extends FlexProps {
  bgColor: string;
  textContent: ReactElement;
  imageContent: ReactElement | null;
}

const BadgeContent: React.FC<Props> = ({
  bgColor,
  textContent,
  imageContent,
  ...containerProps
}) => {
  return (
    <Flex
      bg={bgColor}
      justifyContent="center"
      minHeight="18px"
      px="4px"
      borderRadius={5}
      {...containerProps}
    >
      {imageContent && (
        <Flex direction="column" justifyContent="center" mr="3px">
          {imageContent}
        </Flex>
      )}
      <Flex direction="column" justifyContent="center" lineHeight="18px">
        {textContent}
      </Flex>
    </Flex>
  );
};

export default BadgeContent;
